export function formatTime(
  time: string | number | Date,
  format: Intl.DateTimeFormatOptions = {
    day: "numeric",
    month: "long",
    year: "numeric",
  },
): string {
  return new Intl.DateTimeFormat("nl", format).format(new Date(time));
}

export function formatFullTime(time: string | number | Date) {
  return formatTime(time, {
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
